import { Banner } from "#ui/banner";
import { Container } from "#ui/container";
import { Main } from "#ui/main";
import { Steps } from "#ui/steps";
import type { StepsItems } from "#ui/steps.components";

interface PageProgressProps extends React.PropsWithChildren {
  //TODO: props appropriate for progress indicator (list of options + current option?)
  steps: StepsItems;
  current: number;
}

export function PageProgress({ steps, current, children }: PageProgressProps) {
  return (
    <Main>
      <Banner className="md:-mb-[90px] md:pb-[130px]">
        <Container>
          <Steps activeIndex={current} items={steps} />
        </Container>
      </Banner>
      <Container className="grid justify-items-center">
        <div className="gap-8 grid w-full max-w-800px">{children}</div>
      </Container>
    </Main>
  );
}
